/*
 *  Classe proxy per l'utility console di Javascript
 *
 *  l'obiettivo è evitare console.log in prod
 *
 *  https://developer.mozilla.org/en-US/docs/Web/API/console
 */ 

// import * as env from '@assets/data/appConfig.json';
const env = require('@assets/data/appConfig.json');

class Logger {

  private isProd = env.production;
  private bindingConsole = (fn: Function) => !this.isProd ? fn.bind(console) : () => {};

  readonly log   = this.bindingConsole(console.log);
  readonly error = this.bindingConsole(console.error);
  readonly warn  = this.bindingConsole(console.warn);
  readonly debug = this.bindingConsole(console.debug);

  // log2(...msg: any[]) {

  //   if (Logger.isProd()) {
  //     return;
  //   }

  //   // TODO
  //   // formattare bene gli oggetti, che il console.log normale li stampa [Object object]
  //   msg.forEach(x => console.log(x));
  // }
}

export const logger = new Logger();